module.exports = __webpack_public_path__ + "img/block2_img2.189363cd.png";